/**
 * @fileoverview Route guard for the forced change-password page.
 * @description Lets through only a signed-in user whose session is restricted (mustChangePassword).
 * A signed-out visitor goes to /login; a signed-in user who doesn't need to change their password
 * goes to their resolved destination (see `resolveSignedInDestination`) — a voluntary change
 * happens in the Settings modal, not on this page. The mirror of this check lives in
 * ProtectedRoute, which sends a restricted user here from every dashboard-area route.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { Navigate, Outlet } from 'react-router'

import { ROUTES } from '@/shared/constants/routes.constants'
import { resolveSignedInDestination } from '@/shared/lib/auth/resolve-home-route'
import { useAuth } from '@/shared/lib/auth/useAuth'

/**
 * @component
 */
function ForcePasswordChangeRoute() {
  const { isAuthenticated, user } = useAuth()

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />
  }

  if (!user?.mustChangePassword) {
    return <Navigate to={resolveSignedInDestination(user)} replace />
  }

  return <Outlet />
}

export default ForcePasswordChangeRoute
